<template lang="pug">
  .root
    the-heading(:caption="'Учётные записи'" :breadcrumbs="breadcrumbs")
    .container
      .main_block
        .globalCaptionStyles.localCaption Учётные записи
        .filter_block
          Keypress(:key-code="13" event="keyup" @pressed="find")
          .fields
            .item
              label Фамилия
              .field_container
                WebiomedInput(v-model="filter.last_name__icontains" :value="filter.last_name__icontains")
            .item
              label Имя
              .field_container
                WebiomedInput(v-model="filter.first_name__icontains" :value="filter.first_name__icontains")
            .item
              label Отчество
              .field_container
                WebiomedInput(v-model="filter.second_name__icontains" :value="filter.second_name__icontains")
            .item
              label Учетная запись
              .field_container
                WebiomedInput(v-model="filter.username__icontains" :value="filter.username__icontains")
            .item
              label Название МО
              .field_container
                WebiomedSearchField(
                  v-model="filter.hospital_name__icontains"
                  :value="filter.hospital_name__icontains"
                  :search_by="'hospital_name'",
                  :show="'hospital_name'"
                  :address="'webiomedmpi/requests/hospital-names/'"
                  :fieldAdd="'?hospital_name__icontains='"
                  :placeholder="'Введите название МО...'"
                  :icons="'clinic-medical'",
                  :namespase="'Users'"
                  )
            .item(v-if="regionOptions.length")
              label Регион
              .field_container
                WebiomedSelect(:options="regionOptions" :value="filter.region__fias_id" v-model="filter.region__fias_id")
            //-     WebiomedSearchField(
            //-       v-model="filter.region"
            //-       :value="filter.region"
            //-       :search_by="'id'"
            //-       :show="'formalname'"
            //-       :additional_name="'shortname'"
            //-       :address="'nsi/values/sys-fias-entities/?aolevel=1&formalname__icontains='"
            //-       :placeholder="'Введите регион...'"
            //-       :icons="'globe'"
            //-       )
          .buttons
            button.find(@click="find") Найти
            button.clear(@click="clear") Очистить фильтры
            //- v-icon(name="notes-medical sx")
            div(style="display: inline-block; margin-left: 5px;") Количество записей:
            span(style="font-weight: 450") {{' ' +count}}
        //- .additional_buttons(id="additionalBtn")
        //-   button.add(@click="goToAddState")
        //-     span(style="font-weight: bold; font-size: 18px") +
        //-     span Добавить
        page-grid(:cols="cols" ref="grid" :response="data" :nextState="nextState" :count="count")
</template>
<script>
import axios from 'axios'
import TheHeading from '@/components/parts/TheHeading'
import WebiomedInput from '@/components/fields/WebiomedInput'
import WebiomedSearchField from '@/components/fields/WebiomedSearchField'
import WebiomedSelect from '@/components/fields/WebiomedSelect'
import PageGrid from '../parts/PageGrid'
import pageGridMixin from '@/mixins/pageGridMixin'
import breadcrumbs from '@/data/breadcrumbs/NSI'
import cols from '@/data/cols/users'

export default {
  components: {
    PageGrid,
    TheHeading,
    WebiomedInput,
    WebiomedSearchField,
    WebiomedSelect,
    breadcrumbs,
    Keypress: () => import('vue-keypress')
  },
  mixins: [pageGridMixin],
  data () {
    return {
      regionOptions: [],
      address: 'gate/api/v1/accounts/?',
      api: '',
      breadcrumbs,
      cols,
      nextState: 'UserSummary',
      addState: 'UserAdd',
      results: []
    }
  },
  created () {
    if (this.$route.query) {
      for (let key in this.$route.query) {
        if (key !== 'hospital_name__icontains' && key !== 'region') {
          this.filter[key] = this.$route.query[key]
        }
      }
    }

    axios.get('gate/api/v1/accounts/get-user-regions/').then(regions => {
      regions.data.forEach(item => {
        item['id'] = item['region_id']
        item['name'] = item['region_text']
        delete item['region_id']
        delete item['region_text']
      })
      this.regionOptions = regions.data
    })
    localStorage.removeItem('sParams')
  },
  methods: {
    setData (response) {
      this.data = response.map(item => {
        return {
          id: item.id,
          hospital_name: item.hospital_name,
          region_name: item.region_name,
          username: item.username,
          full_name:
            item.first_name + ' ' + item.last_name + ' ' + item.second_name,
          is_active: item.is_active ? 'Да' : 'Нет'
        }
      })
    },
    goToAddState () {
      this.$router.push({ name: this.addState })
    }
  }
}
</script>
<style lang="sass" scoped>
@import "@/css/pageGridStyles.sass"
.buttons
  margin: 50px 40px 30px 40px
#additionalBtn
  margin-left: 40px
@media screen and (max-width: 1460px)
  .fields
    grid-template-columns: 1fr 1fr

@media screen and (max-width: 1120px)
  #additionalBtn
    margin-left: 10px

@media screen and (max-width: 1000px)
  .fields
    grid-template-columns: 1fr
    width: 95vw
    justify-content: center
</style>
<style lang="sass">
.Users
  font-size: 15px
  height: 32px
</style>
